import React from 'react';

const Triangle = () => {
    return (
        <div className="triangle">
            <div className="triangle__inner">
            </div>
        </div>
    )
}

export default Triangle